<template>
	<div class="layout-menu-container flex flex-column">
		<AppSubmenu :items="model" class="layout-menu" :root="true" @menuitem-click="onMenuItemClick" @keydown="onKeyDown" />
		<span class="pt-5">
			<!-- IE 2026 09 23 / ODOO-341407: i18n -->
			<div v-wjTooltip="t('Go to {site}', { site: '<b class=\'tooltip-header\'>webscm.ai</b>' }) + '<br>' + t('(opens in a new tab)') + '<br><br>' + store?.version_frontend + '<br>' + store?.version_backend">
				<a
					:href="store?.url"
					target="_blank"
					rel="noopener noreferrer"
				><span class="logo1">Web</span><span class="logo">SCM</span></a>
			</div>
			<!-- <div class="versions-container">
				<div class="versions">
					{{ store.version_frontend }} <br>
					{{ store.version_backend }}
				</div>
			</div> -->
		</span>
	</div>
</template>

<script>
import AppSubmenu from './AppSubmenu'
import { useMainStore } from '@/stores/mainStore'
import { onMounted } from 'vue'

export default {
	props: {
		model: Array
	},
	data: () => ({ 
    }),
    setup() {
		// onMounted(() => {
		// 	const e = document.querySelector('div a[href*="wijmo"]')
		// 	if (e) {
		// 		e.parentElement.remove()
		// 	}
		// });
			
        const store = useMainStore();
        return { store }
    },
    // created() {
    //     console.log(`created`)
    // },
    methods: {
        onMenuItemClick(event) {
            this.$emit('menuitem-click', event);
        },
		onKeyDown(event) {
			const nodeElement = event.target;
			if (event.code === 'Enter' || event.code === 'Space') {
				nodeElement.click();
				event.preventDefault();
			}
		},
		bannerImage() {
			return this.$appState.darkTheme ? 'images/banner-primeblocks-dark.png' : 'images/banner-primeblocks.png';
		}
    },
	computed: {
		darkTheme() {
			return this.$appState.darkTheme;
		}
	},
	components: {
		'AppSubmenu': AppSubmenu
	}
}
</script>

<style scoped>
.logo1 {
    font-size: 1.7rem;
    font-weight: 900 !important;
    /* letter-spacing: -1.5px !important; */
    background: -webkit-linear-gradient(315deg, #42d392 25%, #4db9b5);
    /* -webkit-background-clip: text; */
    /* -webkit-text-fill-color: transparent; */
    margin-top: 41px;
    margin-bottom: 41px;
    font-stretch: ultra-condensed;
    border-radius: 3px;
    color: #ecf0f3;
    padding-inline: 0.4rem;
    margin: 0.1rem;
}
.logo {
	font-size: 1.7rem;
    font-weight: 900 !important;
    letter-spacing: -1.5px !important;
	background: -webkit-linear-gradient(315deg,#51acc3 25%,#647eff);
	-webkit-background-clip:text;
	-webkit-text-fill-color:transparent;
	margin-top: 41px;
	margin-bottom: 41px;
}

.versions-container {
    display: flex;
    justify-content: space-between;
    width: 100%;
    padding: 10px;
    position: absolute;
    bottom: 0;
    left: 0;
}

.versions {
	color: gray;
    font-size: 1rem;
    margin: 0 10px;
}
</style>